import { Typography } from '@mui/material'
import { Button, Modal } from 'eezy-components'
import { useTranslation } from 'react-i18next'

type Props = {
  isOpen: boolean
  setOpen: (open: boolean) => void
  onConfirm: () => void
  confirming: boolean
}

const AcceptModal = ({
  isOpen,
  setOpen,
  onConfirm,
  confirming,
}: Props): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Modal modalOpen={isOpen} setModalOpen={setOpen} size="larger">
      <Modal.Header>
        {t('review.pending_submissions.application_approval.title')}
      </Modal.Header>

      <Modal.Body>
        <Typography variant="body1" textAlign="center">
          {t('review.pending_submissions.application_approval.warning')}
        </Typography>
      </Modal.Body>

      <Modal.Actions>
        <Button onClick={() => setOpen(false)} disabled={confirming}>
          {t('cancel')}
        </Button>
        <Button
          color="primary"
          onClick={onConfirm}
          disabled={confirming}
          loading={confirming}
          testId="confirm-button"
        >
          {t('util.submit')}
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default AcceptModal
